module.exports = __webpack_public_path__ + "img/icon-item-default.a0214e08.svg";